import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  ToastController,
  ActionSheetController,
  Modal,
  ModalController,
  ActionSheet,
} from "ionic-angular";
import { Proxy } from "../../services/proxy/proxy.service";
import { APIOnLine } from "../../services/api/api.services";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { PaginaBasica } from "../../models/PaginaBase";
import { NuevaPersonaPage } from "../nueva-persona/nueva-persona";
import { ModalImagePage } from "../modal-image/modal-image";

@IonicPage()
@Component({
  selector: "page-entrenadores",
  templateUrl: "entrenadores.html",
})
export class EntrenadoresPage extends PaginaBasica {
  // #region Propiedades de la página
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  // #endregion

  // #region Propiedades para la "presentación" de los entrenadores
  public presentaEntrenador: string = "";
  // #endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public Persistentes: APIOnLine.Persistentes,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidEnter() {
    console.log("--- ENTRO EN LA PÁGINA: ENTRENADORES ---");
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    this.participantes = new Proxy.ListaPrParticipacion(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.toastCtrl,
      this.designacion,
      this.idEquipo
    );
    this.licencias = new Proxy.ListaPrPersonaAlineable(
      this.CFutbolActas,
      this.DBService2,
      this.Persistentes,
      this.designacion,
      this.idEquipo
    );

    this.MostrarOcultarCarga(false, "cargando entrenadores");

    this.participantes
      .CargarListaParticipacion()
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(false, true, false);
      })
      .then((resultado: boolean) => {
        this.MostrarOcultarCarga();

        console.log("Otros datos");
        console.log(this.designacion.OtrosDatos);

        if (this.PresentaEntrenadorEstablecido()) {
          this.presentaEntrenador = this.PresentaEntrenador() ? "si" : "no";
        }
      })
      .catch((error) => console.error(error));
  }

  // #region Métodos del controlador

  public ColorEntrenador(licencia: Proxy.PrPersonaAlineable): string {
    if (this.participantes.EsEntrenador(licencia)) {
      return "green-sea";
    } else {
      return "concrete";
    }
  }

  public EliminarDatos(): void {
    let action: ActionSheet = this.actionSheetCtrl.create({
      buttons: [
        {
          text: "REINICIAR",
          handler: () => {
            this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
            this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

            if (this.designacion.EquipoLocal(this.idEquipo)) {
              this.designacion.OtrosDatos.presentaEntrenadorLocal = null;
            } else {
              this.designacion.OtrosDatos.presentaEntrenadorVisitante = null;
            }
            this.designacion.OtrosDatos.Guardar();
            this.presentaEntrenador = "";

            if (this.participantes.TieneEntrenador()) {
              this.participantes
                .EliminarEntrenador()
                .then((resultado: boolean) => {
                  console.log("Se ha eliminado al entrenador");
                });
            }
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
          handler: () => {},
        },
      ],
      title: "Reiniciar datos",
      subTitle:
        "Si desea eliminar los datos introducidos actualmente, seleccione la opción REINICIAR.",
    });
    action.present();
  }

  public EliminarParticipante(licencia: Proxy.PrPersonaAlineable): void {
    let actionSheet = this.actionSheetCtrl.create({
      title: "Eliminar participante",
      subTitle:
        "¿Desea eliminar de la lista de entrenadores a " +
        licencia.nombre +
        " " +
        licencia.apellido1 +
        " " +
        licencia.apellido2 +
        "?",
      buttons: [
        {
          text: "Eliminar",
          handler: () => {
            this.participantes.EliminarParticipante(licencia);
            this.licencias.EliminarAlineado(licencia);
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  /**
   * Carga la página que se encarga de añadir una nueva persona a la lista de jugadores
   */
  public NuevaPersona(): void {
    let modal: Modal = this.modalCtrl.create(NuevaPersonaPage, {
      esAuxiliar: false,
      esEntrenador: true,
    });
    modal.onDidDismiss(() => {
      this.participantes
        .CargarListaParticipacion()
        .then((resultado: boolean) => {
          return this.licencias.ObtenerAlineables(false, true, false);
        })
        .then((resultado: boolean) => {})
        .catch((error) => console.error(error));
    });
    modal.present();
  }

  /**
   * Muestra una ventana modal con la foto asociada a la persona
   * @param licencia Datos de la licencia
   */
  public VerFoto(licencia: Proxy.PrPersonaAlineable): void {
    let modal: Modal = this.modalCtrl.create(ModalImagePage, {
      dni: licencia.identificador,
    });
    modal.present();
  }

  // #endregion

  // #region Métodos relacionados con el control de presencia del Entrenador

  public ActivarEntrenadores(): void {
    if (this.designacion.EquipoLocal(this.idEquipo)) {
      this.designacion.OtrosDatos.presentaEntrenadorLocal = true;
    } else {
      this.designacion.OtrosDatos.presentaEntrenadorVisitante = true;
    }
    this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
    this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

    this.designacion.OtrosDatos.Guardar();
  }

  /**
   * Se indica que el equipo no presenta entrenador. Se pide confirmación para guardar ese valor.
   */
  public NoPresentaEntrenador(): void {
    let action: ActionSheet = this.actionSheetCtrl.create({
      buttons: [
        {
          text: "NO PRESENTA",
          handler: () => {
            if (this.designacion.EquipoLocal(this.idEquipo)) {
              this.designacion.OtrosDatos.presentaEntrenadorLocal = false;
            } else {
              this.designacion.OtrosDatos.presentaEntrenadorVisitante = false;
            }

            this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
            this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

            this.designacion.OtrosDatos.Guardar().then((resultado: boolean) => {
              this.Mensaje(
                "El equipo " +
                  (this.designacion.EquipoLocal(this.idEquipo)
                    ? this.designacion.local
                    : this.designacion.visitante) +
                  " no presenta entrenador."
              );

              if (this.participantes.TieneEntrenador()) {
                this.participantes
                  .EliminarEntrenador()
                  .then((resultado: boolean) => {
                    console.log("Se ha eliminado al entrenador");
                  });
              }
            });
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
          handler: () => {
            if (this.designacion.EquipoLocal(this.idEquipo)) {
              this.designacion.OtrosDatos.presentaEntrenadorLocal = null;
            } else {
              this.designacion.OtrosDatos.presentaEntrenadorVisitante = null;
            }
            this.presentaEntrenador = "";
          },
        },
      ],
      title: "No presenta entrenador",
      subTitle:
        "Seleccione la opción de NO PRESENTA para indicar que el equipo " +
        (this.designacion.EquipoLocal(this.idEquipo)
          ? this.designacion.local
          : this.designacion.visitante) +
        " no presenta entrenador.",
    });
    action.present();
  }

  /**
   * Indica si se ha indicado que se presenta el entrenador.
   */
  public PresentaEntrenador(): boolean {
    if (
      this.designacion != null &&
      this.designacion.OtrosDatos != null &&
      ((this.designacion.OtrosDatos.presentaEntrenadorLocal == true &&
        this.designacion.EquipoLocal(this.idEquipo)) ||
        (this.designacion.OtrosDatos.presentaEntrenadorVisitante == true &&
          !this.designacion.EquipoLocal(this.idEquipo)))
    ) {
      return true;
    } else {
      return false;
    }
  }

  public PresentaEntrenadorEstablecido(): boolean {
    if (
      this.designacion != null &&
      this.designacion.OtrosDatos != null &&
      (((this.designacion.OtrosDatos.presentaEntrenadorLocal == true ||
        this.designacion.OtrosDatos.presentaEntrenadorLocal == false) &&
        this.designacion.EquipoLocal(this.idEquipo)) ||
        ((this.designacion.OtrosDatos.presentaEntrenadorVisitante == true ||
          this.designacion.OtrosDatos.presentaEntrenadorVisitante == false) &&
          !this.designacion.EquipoLocal(this.idEquipo)))
    ) {
      return true;
    } else {
      return false;
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/entrenadores/entrenadores.ts